import React from 'react';
import { useLang } from '../i18n/LanguageContext';

const SideContact = () => {
  const { t } = useLang();
  return (
    <a href="#contact" className="side-contact hidden md:block" aria-label="Contact us">
      {t('side.contact')}  ▲
    </a>
  );
};

export default SideContact;
